import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Router } from '@angular/router';
import { CallBackService } from '../services/CallBack.service';
import { AuthService } from '../../authmanagement/services/Auth.service';
import { SessionService } from '../../../shared/services/Session.service';
import { LocalStorageService } from '../../../shared/services/LocalStorage.service';

import { environment } from "src/environments/environment";
import { MAP_BUILD_NAMES } from 'src/models/common/EnumMapas';
import { EnumExternalMapUrl } from 'src/app/features/shared/helpers/enums/EnumCatalogNames copy';

@Component({
  selector: 'app-callbackPage',
  templateUrl: './callbackPage.component.html',
  styleUrls: ['./callbackPage.component.css']
})
export class CallbackPageComponent implements OnInit {

  error : boolean = false;

  constructor(private callbackService: CallBackService,
    private authService: AuthService,
    private sessionService: SessionService,
    private router: Router,
    private localStorageService: LocalStorageService) { }

  ngOnInit(): void {
    try{
      // this.updateToDefault().then((data: any) => {
      //   if (data.isSuccess) {
      //     this.callbackService.dataCallback().then((data: any) => {
      //       this.router.navigate(["/unifiedMap"]);
      //     });
      //   }else{
      //     this.error = true;
      //     setTimeout(() => {
      //       let resp = this.authService.Logout();
      //     }, 4000);
      //   }
      // });

      var mapUrl = this.callbackService.getMapUrl();
      var externalMapNames = Object.values(EnumExternalMapUrl).map(x => x.toString());
      if(!this.sessionService.isMapix || externalMapNames.includes(mapUrl)){
        
        this.callbackService.minifiedCallback().then((data: any) => {
          mapUrl = this.callbackService.getMapUrl();
          if(this.callbackService.isCallBackSuccesfull){
              this.router.navigate([mapUrl]);
          }else{
            this.router.navigate(["/error"]);
          }
        });
        return;
      }

      this.callbackService.dataCallbackOneCall(true).then((data: any) => {
        if(this.callbackService.isCallBackSuccesfull){
          mapUrl = this.callbackService.getMapUrl();
          if(mapUrl){
            this.router.navigate([mapUrl]);
          }else{
            this.router.navigate(["/unifiedMap"]);
          }
        }else{
          this.router.navigate(["/error"]);
        }
      });
      
    }
    catch(e){
      if(!environment.production) console.log(e);
      this.error = true;
      setTimeout(() => {
        let resp = this.authService.Logout();
      }, 4000);
      
    }
  }

  ngOnDestroy(): void {
  }

  async updateToDefault(){
    return await firstValueFrom(this.authService.UpdateDefaultClientId());
  }

}
